<app-header [label]="page_name"></app-header>
<div class="flex bg-white gap-4 items-center justify-between p-4">
  <app-search-input #searchbar></app-search-input>
  <app-dropdown-upload-button [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"> </app-dropdown-upload-button>
</div>
<app-ag-grid-list [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)"></app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="YES" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete Exam.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids.is_active)" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} Exam
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      <app-select-input label="Academic Year" class="w-full" [is_required]="true" formControlName="academic_year_id" [options]="dds.dropdown_list?.academic_list"></app-select-input>
      <app-select-input label="School" class="w-full" [is_required]="true" formControlName="university_id" [options]="dds.dropdown_list?.university_list"></app-select-input>
      <app-select-input label="School Branch" class="w-full" [is_required]="true" formControlName="college_id" [options]="form.get('university_id')?.value ? (dds.dropdown_list?.college_list | filterByKeyAndValue : 'university_id' :form.get('university_id')?.value) : []"></app-select-input>
      <app-select-input label="Level" class="w-full" [is_required]="true" formControlName="level_id" [options]="dds.dropdown_list?.level_list"></app-select-input>
      <app-select-input label="Program" class="w-full" [is_required]="true" formControlName="program_id" [options]="dds.dropdown_list?.program_list | filterByKeyAndValue : 'University.id' :form.get('university_id')?.value | filterByKeyAndValue : 'Level.id' :form.get('level_id')?.value"></app-select-input>
      <!-- <app-select-input label="Subject" class="w-full" [is_required]="true" formControlName="subject_id" [options]="dds.dropdown_list?.subject_list"></app-select-input> -->
      <app-select-input label="Stream" class="w-full" [is_required]="true" formControlName="stream_id" [options]="dds.dropdown_list?.stream_list"></app-select-input>
      <app-text-input type="number" class="w-full" [label]="'Credits'" formControlName="credits"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]="page_name + ' Name'" formControlName="name"></app-text-input>
      <app-text-input [is_required]="true" class="w-full" [label]="' Code'" formControlName="code"></app-text-input>
      <app-text-input type_total_latter="10" type="number" class="w-full" [label]="'Contact Number'" formControlName="contact"></app-text-input>
      <app-text-input class="w-full" [label]="'Email'" formControlName="email"></app-text-input>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="selected_ids.id ? 'Update' :'Add'" type="button" [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Academic year</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.AcademicYear?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">School Branch</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.College?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">School</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.University?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Level Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Level?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Program Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Program?.name || '—' }}</p>
    </div>
    <!-- <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Subject Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Subject?.name || '—' }}</p>
    </div> -->
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Stream Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.Stream?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Credits</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.credits || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Name</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}} Code</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.code || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Email</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.email || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Contact</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.contact || '—' }}</p>
    </div>
  </div>
</app-modal>